import useStore from "../../../store"
import Spinner from "../../common/Spinner"
import UnitTable from "./UnitTable"
import NoCurrentUnits from "./NoCurrentUnits"
import SearchBar from "../../common/SearchBar"
import { useTranslation } from "react-i18next"
import UnitsFilterByDrawer from "../../AccountManager/Dealer/Units/UnitsFilterByDrawer"
import TableFilterIndicators from "../../common/TableFilterIndicators"
import AmSearchBar from "../../common/AmSearchBar"
import { IoMdDownload } from "react-icons/io"
import { currentUnitsDownloadEnabled } from "../../../utilities/featureFlags"
import { useState } from "react"
import { colors } from "../../../utilities/colors"
import useUserType from "../../../hooks/useUserType"
import { Widget, WidgetBody, WidgetHeader, WidgetFooter } from "../../ui/Widget"
import Pagination from "../../common/Pagination"

export default function CurrentUnits() {
  const { t } = useTranslation()
  const { isDealer, isAccountManager } = useUserType()
  const today = new Date().toLocaleDateString('en-ZA')
  const setDealerUnitsPage = useStore((state) => state.setDealerUnitsPage)
  const units = useStore((state) => state.units)
  const unitsFetching = useStore((state) => state.unitsFetching)
  const user = useStore((state) => state.user)
  const amUnitsTableParams = useStore((state) => state.amUnitsTableParams)
  const setAmUnitsTableParams = useStore((state) => state.setAmUnitsTableParams)
  const dealerUnitsSearchBarValue = useStore((state) => state.dealerUnitsSearchBarValue)
  const setDealerUnitsSearchBarValue = useStore((state) => state.setDealerUnitsSearchBarValue)
  const dealer = useStore((state) => state.dealer)
  const selectedDealerUnitsScopeLabel = useStore((state) => state.selectedDealerUnitsScopeLabel)
  const setSelectedDealerUnitsScopeLabel = useStore((state) => state.setSelectedDealerUnitsScopeLabel)
  const downloadCurrentUnits = useStore((state) => state.downloadCurrentUnits)
  const downloadingUnits = useStore((state) => state.downloadingUnits)
  const { currentPage, lastPage, dealerUnitsResultsCount, totalPages } = useStore((state) => state.dealerUnitsPaginationData)
  const [isFilterOpen, setIsFilterOpen] = useState(false)

  const unitsBody = () => {
    if (units?.length > 0 && units[0]?.attributes['dealer-id'] == dealer?.id) {
      return <UnitTable searchTerm={dealerUnitsSearchBarValue} setSearchTerm={setDealerUnitsSearchBarValue}/>
    } else if (units?.length === 0 && !unitsFetching) {
      return <NoCurrentUnits />
    } else {
      return null
    }
  }

  const handleReset = () => {
    setAmUnitsTableParams('')
    setDealerUnitsSearchBarValue('')
  }

  const handlePageClick = (event) => {
    setDealerUnitsPage(event.selected + 1)
  }

  const headerIcon = () => {
    if (isDealer && currentUnitsDownloadEnabled) {
      return <IoMdDownload
        color={colors.grey300}
        onClick={() => downloadCurrentUnits(user, today)}
        data-testid="units-download"
        className="w-6 h-6 hover:cursor-pointer"
      />
    }
  }

  const showBody = !unitsFetching || (units?.length > 0 && (Number(units[0]?.attributes['dealer-id']) === Number(dealer?.id)))

  return (
    <Widget>
      {isAccountManager ?
        <div className="px-1">
          <AmSearchBar
            handleSearch={setDealerUnitsSearchBarValue}
            handleReset={handleReset}
            onOpen={() => setIsFilterOpen(true)}
            showFilterIcon={true}
            dataFetching={unitsFetching}
            searchBarValue={dealerUnitsSearchBarValue}
            setSearchBarValue={setDealerUnitsSearchBarValue}
          />
        </div>
        :
        <WidgetHeader
          title={isDealer ? t('Current Units') : ''}
          actionIcon={headerIcon()}
          showSpinner={isDealer && (downloadingUnits || !showBody)}
        >
            <SearchBar
              onChange={setDealerUnitsSearchBarValue}
              value={dealerUnitsSearchBarValue}
              handleReset={() => setDealerUnitsSearchBarValue('')}
            />
        </WidgetHeader>
        }

      {isAccountManager &&
        <>
          <UnitsFilterByDrawer
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
          />
          <TableFilterIndicators
            onClose={() => setIsFilterOpen(false)}
            filterParams={amUnitsTableParams['filter[scope]']}
            setFilterParams={setAmUnitsTableParams}
            selectedScopeLabel={selectedDealerUnitsScopeLabel}
            resetFilters={['filter[scope]']}
            setSelectedScopeLabel={setSelectedDealerUnitsScopeLabel}
          />
        </>
      }

      <WidgetBody
        isVisible={showBody}
      >
        {unitsBody()}
      </WidgetBody>

      {isAccountManager &&
        <WidgetFooter isSticky>
          <Pagination
            currentPage={currentPage}
            lastPage={lastPage}
            dataTotal={dealerUnitsResultsCount}
            handlePageClick={handlePageClick}
            totalPages={totalPages}
          />
        </WidgetFooter>
      }
    </Widget>
  )
}
